import React from "react"
import { PersistGate } from "redux-persist/integration/react"
import { Provider } from "react-redux"

import { ApolloProvider } from "@apollo/client"
import { CouponsProvider } from "../components/CouponsProvider"
import { CartProvider } from "../components/template-parts/checkout/CartProvider"
import { AuthProvider } from "../components/AuthProvider"
import AppVersionGate from "../components/AppVersionGate"
import { persistor, store } from "../store/store"
import apolloClientNext from "../ApolloClientNext"

export const withDynamicApp =
  <T extends {}>(Component: React.FC<T>) =>
  (props: T) => (
    <Provider store={store}>
      <ApolloProvider client={apolloClientNext}>
        <AuthProvider>
          <AppVersionGate>
            <PersistGate loading={null} persistor={persistor}>
              <CouponsProvider>
                <CartProvider>
                  <Component {...props} />
                </CartProvider>
              </CouponsProvider>
            </PersistGate>
          </AppVersionGate>
        </AuthProvider>
      </ApolloProvider>
    </Provider>
  )
